import React from "react";
import PageHeader from "../components/PageHeader";
import ExcellenceSection from "../components/ExcellenceSection";
import VisionSection from "../components/VisionSection";
import MissionSection from "../components/MissionSection";
import CorePhilosophy from "../components/CorePhilosophy";
import GandhiCentre from "../components/GandhiCentre";
import QualityPolicy from "../components/QualityPolicy";
import QualityObjectives from "../components/QualityObjectives";
const VisionMission = () => {
  return (
    <div className="vision-mission-page">
      <PageHeader />
      <ExcellenceSection />
      <VisionSection />
      <MissionSection />
      <CorePhilosophy />
      <GandhiCentre />
      <QualityPolicy />
      <QualityObjectives />
      {}
    </div>
  );
};

export default VisionMission;
